import React from 'react';
import { Row, Col } from 'react-bootstrap';

export const BlockWithImage = ({ title, text, image, pull }) => {
	let contentColumn = ['content-column'];
	if (pull) {
		contentColumn.push('pull-right');
	}

	let imageColumn = ['image-column'];
	if (pull) {
		imageColumn.push('pull-left');
	}

	const backgroundImage = {
		backgroundImage: `url('${require('../../../assets/images/about')[image]}')`,
	};

	return (
		<section className="abouts testimonials-section">
			<div className="auto-container">
				<Row className="clearfix">
					<Col className={contentColumn.join(' ')} lg={7} md={12} sm={12} xs={12}>
						<div className="inner">
							<div className="sec-title">
								<h2>{title}</h2>
								<div dangerouslySetInnerHTML={{ __html: `${text}` }} />
							</div>
						</div>
					</Col>

					<Col className={imageColumn.join(' ')} md={5} sm={12} xs={12}>
						<div className="clearfix">
							<div className="out-box">
								<div className="image-box" style={backgroundImage} />
							</div>

						</div>
					</Col>
				</Row>
			</div>
		</section>
	);
};



// WEBPACK FOOTER //
// ./src/components/ui/BlockWithImage/BlockWithImage.js